/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'beatpulse-download': {
    width: 15.939,
    height: 15.939,
    viewBox: '0 0 15.939 15.939',
    data: '<defs><clipPath id="svgicon_beatpulse-download_a"><path pid="0" data-name="Rectangle 1759" _fill="#a4a4a4" d="M0 0h15.939v15.939H0z"/></clipPath></defs><g clip-path="url(#svgicon_beatpulse-download_a)"><path pid="1" d="M7.366 8.93v-7a.604.604 0 1 1 1.207 0v7l2.29-2.29a.604.604 0 1 1 .854.854l-3.321 3.318a.6.6 0 0 1-.854 0l-3.32-3.32a.604.604 0 1 1 .854-.854zm6.038-1.561a.604.604 0 1 1 1.207 0v5.733a1.511 1.511 0 0 1-1.512 1.512H2.84a1.512 1.512 0 0 1-1.512-1.515V7.366a.604.604 0 1 1 1.207 0v5.733a.3.3 0 0 0 .3.3h10.26a.3.3 0 0 0 .3-.3z" _fill="#a4a4a4" data-name="download-1"/></g>'
  }
})
